import { html, LitElement } from 'lit';
import { style } from '../styling/toggle_button';
import { DelegateKBI } from '../delegates/kbi_delegate';

import dom from '@eab-pip/pi-dom';

/**
 * a button to open the knowledge bot
 *
 * @customElement
 * @polymer
 * @element eab-nav-knowledge-bot-toggle
 *
 */
export class NavKnowledgeBotToggleElement extends LitElement {
  static readonly is = 'eab-nav-knowledge-bot-toggle';
  static readonly styles = [style];

  title = 'Knowledge Bot';
  settings: object = {};

  static get properties() {
    return {
      title: {
        type: String
      }
    };
  }

  /**
   *
   */
  render() {
    return html`<button @click=${this.__kbiButton__onClick}>${this.title}</button>`;
  }

  private __kbiButton__onClick(evt: MouseEvent) {
    this.dispatchEvent(new CustomEvent('toggle-clicked'));
  }

  public showKBI(settings: Object) {
    DelegateKBI.instance().show(settings);
  }
}

dom.registerElement(NavKnowledgeBotToggleElement);
